import { reactive } from 'vue'

interface IStore {
  centerHeight: number
}

export const store = reactive<IStore>({
  centerHeight: 0
})
